'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jsColors = require('../style/js-colors');

var _jsColors2 = _interopRequireDefault(_jsColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstLoader = function (_VstComponent) {
  _inherits(VstLoader, _VstComponent);

  function VstLoader(props) {
    _classCallCheck(this, VstLoader);

    var _this = _possibleConstructorReturn(this, (VstLoader.__proto__ || Object.getPrototypeOf(VstLoader)).call(this));

    _this.state = { hidden: props.delay };
    return _this;
  }

  _createClass(VstLoader, [{
    key: 'svgLoader',
    value: function svgLoader() {
      return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', width: '52', height: '52', viewBox: '0 0 52 52' },
        _react2.default.createElement('path', { fill: _jsColors2.default.CLOUD[4], d: 'M26 4c12.1 0 22 9.9 22 22s-9.9 22-22 22S4 38.1 4 26 13.9 4 26 4m0-4C11.6 0 0 11.6 0 26s11.6 26 26 26 26-11.6 26-26S40.4 0 26 0z', opacity: '.8' }),
        _react2.default.createElement('path', { fill: this._theme(7), d: 'M26 0v4c12.1 0 22 9.9 22 22s-9.9 22-22 22v4c14.4 0 26-11.6 26-26S40.4 0 26 0z' })
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.delay) {
        this.delayTimeout = setTimeout(function () {
          _this2.setState({ hidden: false });
        }, this.props.delay);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.hidden) {
        return _react2.default.createElement(
          'div',
          { className: 'vst-loader-container' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'loader' },
              this.svgLoader()
            )
          ),
          _react2.default.createElement(
            'span',
            null,
            this.props.children
          )
        );
      }
      return _react2.default.createElement('span', null);
    }
  }]);

  return VstLoader;
}(_VstComponent3.default);

VstLoader.propTypes = {
  accent: _propTypes2.default.bool,
  delay: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number])
};

VstLoader.defaultProps = {
  accent: true,
  delay: false
};

module.exports = VstLoader;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstLoader.js
 **/